var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z",
    stroke: "#02B151",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z",
    stroke: "#02B151",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14L16 9L5 20",
    stroke: "#02B151",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#02B151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.604 22.168V21.168C5.748 21.168 5.87067 21.16 5.972 21.144C6.07333 21.128 6.15333 21.0987 6.212 21.056C6.27067 21.008 6.31333 20.9413 6.34 20.856C6.36667 20.7653 6.38 20.6507 6.38 20.512V15.52H7.812V20.576C7.812 20.928 7.76667 21.224 7.676 21.464C7.59067 21.6987 7.43867 21.8747 7.22 21.992C7.00133 22.1093 6.69467 22.168 6.3 22.168H5.604ZM9.24906 22V15.52H11.4251C11.8144 15.52 12.1344 15.5947 12.3851 15.744C12.6357 15.888 12.8224 16.1013 12.9451 16.384C13.0677 16.6613 13.1291 17 13.1291 17.4C13.1291 17.9013 13.0464 18.2853 12.8811 18.552C12.7157 18.8133 12.4917 18.9947 12.2091 19.096C11.9264 19.1973 11.6091 19.248 11.2571 19.248H10.6811V22H9.24906ZM10.6811 18.248H11.1611C11.3371 18.248 11.4704 18.216 11.5611 18.152C11.6517 18.088 11.7104 17.992 11.7371 17.864C11.7691 17.736 11.7851 17.5733 11.7851 17.376C11.7851 17.2107 11.7717 17.0667 11.7451 16.944C11.7237 16.816 11.6677 16.7147 11.5771 16.64C11.4864 16.5653 11.3451 16.528 11.1531 16.528H10.6811V18.248ZM15.9874 22.096C15.5394 22.096 15.1847 22.0027 14.9234 21.816C14.6674 21.6293 14.4834 21.368 14.3714 21.032C14.2647 20.6907 14.2114 20.2987 14.2114 19.856V17.68C14.2114 17.2213 14.27 16.824 14.3874 16.488C14.5047 16.152 14.7047 15.8933 14.9874 15.712C15.2754 15.5253 15.6647 15.432 16.1554 15.432C16.6354 15.432 17.0114 15.512 17.2834 15.672C17.5607 15.832 17.758 16.0533 17.8754 16.336C17.9927 16.6187 18.0514 16.9493 18.0514 17.328V17.744H16.6514V17.216C16.6514 17.0773 16.6407 16.9493 16.6194 16.832C16.6034 16.7147 16.5607 16.6213 16.4914 16.552C16.4274 16.4773 16.3207 16.44 16.1714 16.44C16.0167 16.44 15.9047 16.4827 15.8354 16.568C15.766 16.648 15.7207 16.7493 15.6994 16.872C15.6834 16.9947 15.6754 17.1227 15.6754 17.256V20.256C15.6754 20.4 15.6887 20.536 15.7154 20.664C15.7474 20.7867 15.8007 20.888 15.8754 20.968C15.9554 21.0427 16.0674 21.08 16.2114 21.08C16.3607 21.08 16.4754 21.04 16.5554 20.96C16.6354 20.88 16.6914 20.776 16.7234 20.648C16.7554 20.52 16.7714 20.384 16.7714 20.24V19.48H16.1874V18.64H18.0594V22H17.1154L17.0354 21.464C16.95 21.6453 16.8247 21.7973 16.6594 21.92C16.494 22.0373 16.27 22.096 15.9874 22.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.de00e440d979c2c507a3d7cffb9fd5ba.svg";
export { ForwardRef as ReactComponent };